import { CTA } from '@volkswagen-onehub/components-core';
import { type CTAProps } from '@volkswagen-onehub/components-core';
import { type ReactNode } from 'react';

interface CTAMailProps {
  mailto: string;
  children?: ReactNode;
  ctaProps?: Omit<CTAProps, 'tag' | 'href'> & { emphasis?: 'primary' | 'secondary' | 'tertiary' | 'none' };
  onClick?: () => void;
}

const CTAMail = ({ mailto, children, ctaProps, onClick }: CTAMailProps) => (
  <CTA
    {...ctaProps}
    tag="a"
    href={`mailto:${mailto}`}
    onClick={onClick}
    data-testid="cta-mail"
  >
    {children || mailto}
  </CTA>
);

export default CTAMail;
